import React from 'react';

import MultiSelectInput from '../MultiSelectInput';

function CheckboxesInput({id, label, question, values, onChange, invalid}) {
  return (
    <MultiSelectInput
      id={id ? id : `answer-${question.id}`}
      label={label}
      values={values}
      options={question.questionOptions.map(option => ({
        key: option.value,
        label: option.value
      }))}
      onChange={values => onChange(values, values.length > 0)}
      invalid={invalid}
    />
  );
}

export default CheckboxesInput;
